<template>
  <div class="animate-pulse rounded-md bg-background-dark" />
</template>
